var LP = LP || {};
(function () {
  var _ = LP;

  _.slider = {};

  _.onDOMContentLoaded = function() {
    _.slider = new Splide('#slider', {
      type        : 'loop',
      width       : '100%',
      fixedWidth  : 'calc(237 / 375 * 100vw)',
      gap         : 'calc(16 / 375 * 100vw)',
      padding     : 'calc(69 / 375 * 100vw)',
      pagination  : false,
      autoplay    : true,
      interval    : 6000,
      mediaQuery  : 'min',
      breakpoints : {
        767       : {
          width       : 'calc(100% - min(102 / 1400 * 100vw, 102px))',
          fixedWidth  : 'min(380 / 1400 * 100vw, 380px)',
          gap         : 'min(30 / 1400 * 100vw, 30px)',
          padding     : 0
        }
      }
    });

    _.slider.on('mounted active', () => {
      document.querySelector('#slider .splide__slideindex').innerHTML = (_.slider.index + 1) +' / '+ (_.slider.Components.Controller.getEnd() + 1);
    });

    _.slider.mount();
  };// -- /_.onDOMContentLoaded
}());// -- /[LP] (function ()


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', LP.onDOMContentLoaded);
} else {
  LP.onDOMContentLoaded();
}